import { createApp } from 'vue';

import MiniCalendarWidget from "./widgets/MiniCalendarWidget";

const miniCalendarWidgetEl = document.querySelector('#miniCalendarWidget');

if (miniCalendarWidgetEl) {
    const miniCalendarWidget = createApp(MiniCalendarWidget,{ ...miniCalendarWidgetEl.dataset })
    miniCalendarWidget.mount("#miniCalendarWidget");
}